module.exports = __webpack_public_path__ + "static/media/3_Foiled_05.1da2366d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/printing-information/Papers/3_Foiled_05.jpg
// module id = 1710
// module chunks = 0